// Module
var code = "<div class=\"sign-out\"> <button type=\"button\" role=\"button\" class=\"jbr-btn jbr-btn--yellow\" ng-if=\"!!$ctrl.webStoreApiClient.account\" ng-class=\"{ 'jbr-btn--loading': $ctrl.loading }\" ng-click=\"$ctrl.onSignOut()\" system-dictionary=\"{{ $ctrl.label }}\"></button> </div> ";
// Exports
module.exports = code;